"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _SVGBase = _interopRequireDefault(require("./SVGBase"));

var _Constants = require("../../Constants");

var _default = (0, _styledComponents.default)(_SVGBase.default).withConfig({
  displayName: "SVGWrapper",
  componentId: "sc-1fqnvin-0"
})(["background-size:cover;background-position:center;display:block;fill:", ";font-family:'Avenir Next W02',Helvetica,Arial,sans-serif;font-size:", "%;text-anchor:middle;width:100%;height:", ";", ";", ";"], function (props) {
  return props._isHasMore ? _colors.OBSIDIAN : 'currentColor';
}, function (props) {
  return props._isHasMore ? '340' : '290';
}, function (props) {
  return props.size && props.size !== _Constants.AVATAR_SIZES.responsive ? _Constants.AVATAR_SIZES[props.size] + "px" : 'inherit';
}, function (props) {
  return props.src ? "background-image: url('" + props.src + "');" : "background-color: " + (props._isHasMore ? _colors.OLAF : _colors.EERIE) + ";";
}, function (props) {
  return /hubfs\/defaults\/company\.png/.test(props.src) && props._isReversed && 'background-position: -2px;';
});

exports.default = _default;
module.exports = exports.default;